import React from "react";
import { TimelineLite } from "gsap/";
import { Form, DataInput, FloatingLableInput, AutoComplete } from "../index";
import { cityOption, genderOptions, razorPayScript } from "../../Constants";
import { register, getPendingOrder, getPayment } from "../Services";
import ThankYouPage from "../ThankYou";
import TermsAndConditions from "../TermsAndConditions";
import CSSPlugin from "gsap/CSSPlugin";
import {getQueryParameters} from "../Utilities";

const C = CSSPlugin;

export default class PlanFormMobile extends React.Component {
  constructor(props) {
    super(props);
    let termsRef = null;
    let { closePlanForm } = this.props;
    this.termsAnimation = new TimelineLite({
      paused: true,
      onComplete: () => {
        this.setState({ showData: true });
      },
      onReverseComplete: () => {},
    });
    this.planFormExitAnim = new TimelineLite({
      paused: true,
      onComplete: () => {
        closePlanForm && closePlanForm();
      },
    });
    this.planFormEntryAnim = new TimelineLite({
      paused: true,
      onComplete: () => {},
    });
  }
  onSubmit = async (data) => {
    let { loading } = this.state || {};
    if (loading) {
      return;
    }
    this.setState({ loading: true });
    let registerResult = await register({ params: data });
    let { code, message } = registerResult || {};
    if (code === 200) {
      let { plans } = this.props;
      let { selectedPlanIndex = 0 } = this.state || {};
      let currentPlan = plans[selectedPlanIndex];
      let product_type = currentPlan.product_type;
      let { plan_master_id, service_tax, actual_amount, selling_amount } =
        currentPlan;
      let { app_key, user_id } = registerResult;
      let transaction_id = user_id + "-" + new Date().getTime();
      const { referral_source, referral_channel } = getQueryParameters();
      let params = {
        user_id,
        plan_master_id,
        transaction_id,
        fit_prime: "0",
        product_type,
        referral_channel: referral_channel || "SBI-YONO",
        workout_price: selling_amount,
        total_order_price: actual_amount,
        service_tax,
        referral_source: referral_source || "SBI-YONO",
        after_discount_price: selling_amount,
        redeemed_points: 0.0,
        membership_plan_id: "",
        corporate_id: 90,
        coupon_code: "",
        payment_mode: "razorpay",
        coupon_type: "",
        coupon_discount: 0.0,
        coupon_id: "",
      };
      let getPendingData = await getPendingOrder({ params, user_id, app_key });
      let { code, razorpay_id } = getPendingData || {};
      if (code === 200) {
        getPayment({
          user_id,
          transaction_id,
          product_type,
          razorpay_id,
          after_discount_price: selling_amount,
          plan_master_id,
          user_details: { ...data, app_key, user_id },
        });
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    } else if (code === 412) {
      this.setState({
        serverErrorMessage: message || "Something went wrong!",
      });
    }
  };

  componentDidMount() {
    window.onresize = () => {
      if (window.innerHeight < 400) {
        this.setState({ showBuyNow: false });
      } else {
        this.setState({ showBuyNow: true });
      }
    };
    const rozarPayScript = document.createElement("script");
    rozarPayScript.src = razorPayScript;
    document.body.appendChild(rozarPayScript);
    this.planFormEntryAnim
      .from(this.planfFormRef, 0.3, { y: 600, opacity: 0, autoAlpha: 0 })
      .to(this.planfFormRef, 0.5, { y: 0, opacity: 1, autoAlpha: 1 })
      .play();

    this.termsAnimation
      // .from(this.planfFormRef, 0.3, { opacity: 1, autoAlpha: 1 })
      .to(this.planfFormRef, 0.3, { opacity: 0, display: "none", autoAlpha: 0 })
      // .from(this.termsRef, 0.3, { opacity: 0, autoAlpha: 0 })
      .to(this.termsRef, 0.3, {
        opacity: 1,
        display: "flex",
        flexDirection: "column",
        autoAlpha: 1,
      });
  }
  closePlanForm = () => {
    let { closeModal } = this.props;
    closeModal && closeModal();
    // this.planFormExitAnim.from(this.planfFormRef, 0.2, { y: 0, opacity: 1, autoAlpha: 1 }).to(this.planfFormRef, 0.2, { y: 700, opacity: 0, autoAlpha: 0 }).play();
  };
  showTermsAndConditions = () => {
    this.termsAnimation.play();
  };
  onCloseTerms = () => {
    this.termsAnimation.reverse();
  };
  render() {
    let { plans, onChangePlan, basicPlanIndex } = this.props;
    let {
      selectedPlanIndex = 0,
      isAgree = true,
      showBuyNow = true,
      serverErrorMessage = "",
    } = this.state || {};
    let { actual_amount, selling_amount, membership_validity } =
      plans[selectedPlanIndex];
    return (
      <>
        <ThankYouPage isMobile />
        <TermsAndConditions
          onClose={this.onCloseTerms}
          getRef={(_) => (this.termsRef = _)}
          isMobile
        />
        <div
          ref={(_) => (this.planfFormRef = _)}
          className="flex-1 flex column planFormContainer scrollY overflowXHidden"
        >
          <div className="rightBlueCircle absolute"></div>
          <div>
            <div className="flex spaceBetween">
              <div>
                <h1
                  style={{ lineHeight: 1.17, marginBottom: 0, marginTop: 0 }}
                  className="c1 f16 bold"
                >
                  CHOOSE YOUR PLAN?
                </h1>
                <div className="homeGradientBar"></div>
              </div>
              <img
                onClick={this.closePlanForm}
                className="mt10"
                height={20}
                width={20}
                src="/images/close_ic@2x.png"
              />
            </div>

            <div className="flex">
              <div
                className={`planSelector ${
                  basicPlanIndex === 0 ? "selectedPlanSelector" : ""
                }`}
                onClick={() => onChangePlan(0)}
              >
                FP PRO
              </div>
              <div
                className={`planSelector ml_12 ${
                  basicPlanIndex === 1 ? "selectedPlanSelector" : ""
                }`}
                onClick={() => onChangePlan(1)}
              >
                FITPASS
              </div>
            </div>
          </div>
          <div className="plansContainerMobile">
            <div className="flex scroll" style={{ background: "white" }}>
              {plans.map((item, index) => {
                let { membership_validity, duration, product_name } = item;
                return (
                  <div
                    onClick={() => {
                      this.setState({ selectedPlanIndex: index });
                    }}
                    className={`f14 mb_10 c1 mobilePlanButton flex-1 medium ${
                      selectedPlanIndex === index
                        ? "selectedMobilePlanButton"
                        : ""
                    }`}
                    style={{ marginLeft: index > 0 ? 15 : 0 }}
                    key={index}
                  >
                    {`${duration} Months`}
                  </div>
                );
              })}
            </div>
            <span className={"c1 f7"}>{`${membership_validity}`}</span>
            <div className="orderSummaryContainer">
              <div className="flex spaceBetween">
                <span className={"f14 medium c1"}>Actual Amount</span>
                <strike className="f14 c5"> ₹{actual_amount}</strike>
              </div>
              {/*<div className="orderSummarySeparator mb5 mt5"></div>*/}
              <div className="flex spaceBetween">
                <span className={"f14 medium c1"}>Payable Amount</span>
                <span className="f14 bold c3"> ₹{selling_amount} </span>
              </div>
              <div className="orderSummarySeparator mb5 mt5"></div>
              <div className="flex">
                <span className="f14 bold c4">
                  All prices include taxes & applicable charges.
                </span>
              </div>
            </div>
          </div>
          <div className="mobilePlanFormContainer">
            <Form
              onSubmit={this.onSubmit}
              mandatoryFields={{
                first_name: "Full Name",
                mobile_no: "Mobile Number",
                email_address: "Email",
                gender: "Gender",
                preferred_location: "City",
              }}
            >
              {(props) => {
                return (
                  <>
                    <div className={"flex-1"}>
                      <DataInput
                        {...props}
                        className="flex-1"
                        field={"first_name"}
                      >
                        <FloatingLableInput
                          key={"fullName"}
                          field={"first_name"}
                          autoFocus
                          label={"Full Name"}
                        />
                      </DataInput>
                      <DataInput
                        {...props}
                        className="flex-1"
                        field={"mobile_no"}
                        validate={{
                          type: "mobile",
                          message: "Please enter valid Mobile No.",
                        }}
                      >
                        <FloatingLableInput
                          key={"mobileNumber"}
                          field={"mobile_no"}
                          autoFocus
                          label={"Mobile Number"}
                        />
                      </DataInput>
                      <DataInput
                        {...props}
                        className="flex-1"
                        field={"email_address"}
                        validate={{
                          type: "email",
                          message: "Please enter valid Email Id",
                        }}
                      >
                        <FloatingLableInput
                          key={"email_address"}
                          field={"email_address"}
                          autoFocus
                          label={"Email"}
                        />
                      </DataInput>
                      <div className="flex">
                        <DataInput
                          {...props}
                          className="flex-1 mt_15"
                          field={"gender"}
                        >
                          <AutoComplete
                            key={"gender"}
                            isSearchable={false}
                            placeholder="Gender"
                            options={genderOptions}
                            field={"gender"}
                            autoFocus
                            label={"Gender"}
                          />
                        </DataInput>
                        <DataInput
                          {...props}
                          className="flex-1 ml12 mt_15"
                          field={"preferred_location"}
                        >
                          <AutoComplete
                            isSearchable={false}
                            key={"preferred_location"}
                            placeholder="City"
                            options={cityOption}
                            field={"preferred_location"}
                            autoFocus
                            label={"Select City"}
                          />
                        </DataInput>
                      </div>
                      {serverErrorMessage && (
                        <div className={"errorStyle"}>{serverErrorMessage}</div>
                      )}
                      <div
                        style={{ marginBottom: 20 }}
                        className="mt12 f12 flex alignCenter mb12"
                      >
                        <div
                          onClick={() => {
                            this.setState({ isAgree: !isAgree });
                          }}
                          style={{
                            background: "#38227a",
                            marginRight: 14,
                            height: 16,
                            width: 16,
                            borderRadius: 3,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isAgree && (
                            <img
                              style={{ height: "80%", width: "80%" }}
                              src="/images/ic_check.svg"
                            />
                          )}
                        </div>
                        I agree to the
                        <div
                          onClick={this.showTermsAndConditions}
                          style={{ textDecoration: "underLine" }}
                          className="ml5"
                          href="http://www.fitpass.co.in"
                        >
                          terms and conditions.
                        </div>
                      </div>
                    </div>

                    {showBuyNow && (
                      <div
                        style={{ bottom: 0, marginTop: 20, marginBottom: 0 }}
                        onClick={props.onSubmit}
                        className="buyNowButton ml20 flex alignCenter"
                      >
                        <span
                          className="c2 f20 medium flex-1"
                          style={{ textAlign: "center" }}
                        >
                          PROCEED
                        </span>
                        <img
                          height="20px"
                          style={{ marginRight: 20 }}
                          src="/images/ic_arrow_forward_24px.svg"
                        />
                      </div>
                    )}
                  </>
                );
              }}
            </Form>
          </div>
        </div>
      </>
    );
  }
}
